import { mergeArraysByIds } from "@qgiv/core-js";

const updateTeamsAction = (_state, action) => {
    const teams = action.payload;

    const oldTeams = _state || [];
    // Merge old teams and new teams, overwriting existing teams
    const newState = mergeArraysByIds(oldTeams, teams);

    return [...newState];
};

export default updateTeamsAction;
